import { Header } from "@/components/store/Header";
import { Hero } from "@/components/store/Hero";
import { Marquee } from "@/components/store/Marquee";
import { ScentGrid } from "@/components/store/ScentGrid";
import { Formula } from "@/components/store/Formula";
import { Reviews } from "@/components/store/Reviews";
import { Faq } from "@/components/store/Faq";
import { FinalCta } from "@/components/store/FinalCta";
import { Footer } from "@/components/store/Footer";
import { CartDrawer } from "@/components/store/CartDrawer";

const StorePage = () => {
  return (
    <div
      data-testid="store-page"
      className="min-h-screen bg-[var(--bg)] text-[var(--ink)] selection:bg-[var(--ink)] selection:text-[var(--bg)]"
    >
      <Header />
      <Hero />
      <Marquee />
      <ScentGrid />
      <Formula />
      <Reviews />
      <Faq />
      <FinalCta />
      <Footer />
      <CartDrawer />
    </div>
  );
};

export default StorePage;
